import React, {useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {VmoDeleteModal} from 'vmo-library'

const DeleteModal = props => {
  const {isLoadingData, type: reducerType, successLabels = []} = useSelector(state => state.apiReducer)
  const {
    idTobeDeleted,
    deleteAction,
    isModalOpen,
    setIsModalOpen,
    modalText = 'Are you sure you want to delete ?',
    onDelete,
    deleteModelHeader = 'Delete',
    type,
    manualDelete = false,
  } = props

  const dispatch = useDispatch()

  useEffect(() => {
    if (successLabels.includes(type)) {
      setIsModalOpen(false)
    }
  }, [successLabels, setIsModalOpen, type])

  return (
    <VmoDeleteModal
      isManual={manualDelete}
      isLoading={isLoadingData && reducerType.includes(type)}
      modalHeader={deleteModelHeader}
      modalContent={modalText}
      open={isModalOpen}
      onClose={() => setIsModalOpen(false)}
      onConfirm={() => {
        if (onDelete) {
          onDelete()
          setIsModalOpen(false)
        } else {
          dispatch(deleteAction(idTobeDeleted))
          setIsModalOpen(false)
        }
      }}
    />
  )
}

export default DeleteModal
